export const slugToId = {
  test: "672312ec5b53fbbe37d4b0d5",
  khiang: "67d3a2144a266ea37ce7ac69",
  khiangmpob: "680e35b78a5a51ec452b6678",
  ebcbaguio: "689154b4dd8b04c79d293a3d",
  ebcsmnorth: "692904adfd404102eb748a69",
  khianggateway: "693a38c27cb578753235bb62",
  ebcgateway: "6a8d012339294a747fd74b22",
};

export const v2Slugs = ["ebcsmnorth", "khianggateway", "ebcbaguio", "ebcgateway"];

export const isMongoId = (s) => /^[a-f0-9]{24}$/i.test(s || "");

const DYNAMIC_ALIAS_STORAGE_KEY = "sparkle:mobileAliasMap";

const readDynamicAliasMap = () => {
  try {
    if (typeof window === "undefined") return {};
    const raw = window.localStorage.getItem(DYNAMIC_ALIAS_STORAGE_KEY);
    return raw ? JSON.parse(raw) || {} : {};
  } catch {
    return {};
  }
};

export const cacheMobileAlias = (alias, posId) => {
  const normalizedAlias = String(alias || "").trim().toLowerCase();
  const normalizedPosId = String(posId || "").trim();
  if (!normalizedAlias || !normalizedPosId) return;

  try {
    const nextMap = {
      ...readDynamicAliasMap(),
      [normalizedAlias]: normalizedPosId,
    };
    window.localStorage.setItem(DYNAMIC_ALIAS_STORAGE_KEY, JSON.stringify(nextMap));
  } catch {
    // Alias caching is an optimization; route resolution can retry next page load.
  }
};

export const resolvePosId = (raw) =>
  isMongoId(raw)
    ? raw
    : slugToId[(raw || "").toLowerCase()] ||
      readDynamicAliasMap()[(raw || "").toLowerCase()] ||
      raw;

export const resolvePosIdForApi = async (
  raw,
  apiBase = process.env.REACT_APP_BACKEND_URL
) => {
  const cachedPosId = resolvePosId(raw);
  if (!raw || isMongoId(cachedPosId) || !apiBase) return cachedPosId;

  try {
    const response = await fetch(
      `${apiBase}/v1/api/stores/resolve/${encodeURIComponent(raw)}`
    );
    if (!response.ok) return cachedPosId;
    const store = await response.json();
    if (store?.mobileAlias && store?.posId) {
      cacheMobileAlias(store.mobileAlias, store.posId);
    }
    return store?.posId || cachedPosId;
  } catch {
    return cachedPosId;
  }
};

export const v2PosIds = v2Slugs.map((s) => slugToId[s]).filter(Boolean);

export const isV2Pos = (raw) => {
  const key = (raw || "").toLowerCase();
  if (v2Slugs.includes(key)) return true;
  return v2PosIds.includes(resolvePosId(raw));
};

export const getRouteSegmentForPosId = (posId) => {
  const dynamicAliases = readDynamicAliasMap();
  const entry = Object.entries({ ...slugToId, ...dynamicAliases }).find(
    ([, id]) => id === posId
  );
  const slug = entry?.[0];
  return slug || posId;
};
